import type { FC } from "react";

import type { DefaultInputFieldProps, IMultiIncludeExcludeFilterProps } from "@similarweb/pro-logic-components";
import { MultiIncludeExcludeFilter } from "@similarweb/pro-logic-components";

import { translate } from "app/filters/i18nFilter";

import type { multiIncludeExcludeType } from "./consts";
import {
    ADD_RULE_TEXT_KEY,
    AUTOCOMPLETE_MAX_ITEMS_BANNER_TEXT_KEY,
    CHIP_SEPARATOR_TEXT_KEY,
    MAX_ITEMS_PER_RULE_BANNER_TEXT_KEY,
    MAX_KEYWORDS_PER_RULE,
    MAX_RULES,
    MAX_RULES_BANNER_TEXT_KEY,
    PRIMARY_BUTTON_TEXT_KEY,
    RULE_SEPARATOR_TEXT_KEY,
    SECONDARY_BUTTON_TEXT_KEY,
    translationKeysMap,
} from "./consts";
import { getDropdownOptions } from "./utils";

type FilterComponentProps = Pick<
    IMultiIncludeExcludeFilterProps,
    "initialRules" | "onDeleteRow" | "onApply" | "onAddRule" | "onCancelClick" | "onUpdateRules"
> & {
    filterType: (typeof multiIncludeExcludeType)[keyof typeof multiIncludeExcludeType];
    TextFieldComponent: FC<DefaultInputFieldProps>;
    errorMessage?: string;
};

export const FilterComponent: FC<FilterComponentProps> = ({
    initialRules,
    onApply,
    onCancelClick,
    onAddRule,
    onUpdateRules,
    onDeleteRow,
    filterType,
    TextFieldComponent,
    errorMessage,
}) => {
    const selectedKeys = translationKeysMap[filterType];

    return (
        <MultiIncludeExcludeFilter
            inputIconName="globe"
            initialRules={initialRules}
            maxItemsPerRule={MAX_KEYWORDS_PER_RULE}
            maxRules={MAX_RULES}
            headerText={translate(selectedKeys.headerTextKey)}
            ruleSeparatorText={translate(RULE_SEPARATOR_TEXT_KEY)}
            addRuleText={translate(ADD_RULE_TEXT_KEY)}
            primaryButtonText={translate(PRIMARY_BUTTON_TEXT_KEY)}
            secondaryButtonText={translate(SECONDARY_BUTTON_TEXT_KEY)}
            chipsSeparatorText={translate(CHIP_SEPARATOR_TEXT_KEY)}
            maxRulesBannerText={translate(MAX_RULES_BANNER_TEXT_KEY, { count: MAX_RULES })}
            maxItemsPerRuleBannerText={translate(MAX_ITEMS_PER_RULE_BANNER_TEXT_KEY, {
                count: MAX_KEYWORDS_PER_RULE,
            })}
            autocompleteMaxItemsBannerText={translate(AUTOCOMPLETE_MAX_ITEMS_BANNER_TEXT_KEY, {
                count: MAX_KEYWORDS_PER_RULE,
            })}
            onApply={onApply}
            onCancelClick={onCancelClick}
            dropDownsOptions={getDropdownOptions(filterType)}
            textBoxWidth={400}
            onAddRule={onAddRule}
            onUpdateRules={onUpdateRules}
            onDeleteRow={onDeleteRow}
            TextFieldComponent={TextFieldComponent}
            errorMessageText={errorMessage}
            isApplyDisabled={!!errorMessage}
            isAddRuleButtonDisabled={!!errorMessage}
        />
    );
};
